// ==================== FORCED PASSWORD CHANGE ====================
// Shown immediately after a temp-password login (must_change_password=true
// on the account) — blocks everything else in the app until submitted.

export function getForcePasswordChangePage() {
  return `
    <div class="login-container">
      <div class="login-card">
        <div class="logo">🔱</div>
        <h1>Set a new password</h1>
        <p class="subtitle">You're using a temporary password — set your own before continuing.</p>

        <div id="fpcError" class="error-msg"></div>

        <form id="forcePasswordChangeForm">
          <div class="form-group">
            <label for="fpcCurrent">Temporary password</label>
            <input type="password" id="fpcCurrent" required autocomplete="current-password">
          </div>
          <div class="form-group">
            <label for="fpcNew">New password</label>
            <input type="password" id="fpcNew" required minlength="8" maxlength="72" autocomplete="new-password">
          </div>
          <div class="form-group">
            <label for="fpcConfirm">Confirm new password</label>
            <input type="password" id="fpcConfirm" required minlength="8" maxlength="72" autocomplete="new-password">
          </div>
          <button type="submit" class="login-btn" id="fpcSubmit">Set password</button>
        </form>
      </div>
    </div>
  `;
}

export function initForcePasswordChangePage(onDone) {
  const form = document.getElementById('forcePasswordChangeForm');
  const errorDiv = document.getElementById('fpcError');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorDiv.textContent = '';
    errorDiv.classList.remove('active');

    const current_password = document.getElementById('fpcCurrent').value;
    const new_password = document.getElementById('fpcNew').value;
    const confirm = document.getElementById('fpcConfirm').value;

    if (new_password !== confirm) {
      errorDiv.textContent = 'New password and confirmation do not match';
      errorDiv.classList.add('active');
      return;
    }

    const btn = document.getElementById('fpcSubmit');
    btn.disabled = true;
    btn.textContent = 'Saving…';

    try {
      const res = await fetch('/api/auth/change-password', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ current_password, new_password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to change password');
      onDone();
    } catch (err) {
      errorDiv.textContent = err.message || 'Failed to change password';
      errorDiv.classList.add('active');
      btn.disabled = false;
      btn.textContent = 'Set password';
    }
  });
}
